import { render, staticRenderFns } from "./exploreResultsDefault.vue?vue&type=template&id=51da2df5"
import script from "./exploreResultsDefault.vue?vue&type=script&lang=js"
export * from "./exploreResultsDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LargeCard: require('/opt/build/repo/frontend/components/cards/largeCard.vue').default,PaginationDefault: require('/opt/build/repo/frontend/components/pagination/paginationDefault.vue').default})
